export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12046.09e0a4e5.jpg";